import ColorHash from 'color-hash'
import { Location } from 'history'
import { nanoid } from 'nanoid'
import isEqual from 'react-fast-compare'
import sha256 from 'tiny-hashes/sha256'

import { APIClient } from './APIClient'
import PublicGlobals from './PublicGlobals'

const colorHash = new ColorHash({ lightness: 0.85 })

export class Utils {
  static isEqual = isEqual

  static getSelectionText() {
    let theText = ''
    if (typeof window.getSelection !== 'undefined') {
      const sel = window.getSelection()
      if (sel.rangeCount) {
        const container = document.createElement('div')
        for (let i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents())
        }
        theText = container.innerText
      }
    } else if (typeof (document as any).selection !== 'undefined') {
      if ((document as any).selection.type === 'Text') {
        theText = (document as any).selection.createRange().htmlText
      }
    }
    return theText
  }

  static getColorHash(content: string): string {
    return colorHash.hex(content)
  }

  static requireFromCDN(assetName: string) {
    return `${PublicGlobals.CDN_BASE_URL}/${assetName}`
  }

  static requireOrgAssetFromCDN(orgId: string, assetName: string) {
    // The backend now returns org logos as self-contained data URLs (and may
    // return absolute CDN URLs in legacy deployments). Call sites embed that
    // value after an `org_logos/` prefix; if the embedded value is already an
    // absolute/data URL, return it directly rather than prefixing the CDN base.
    const absolute = assetName.match(/(data:|https?:\/\/).*/)
    if (absolute) {
      return absolute[0]
    }

    return `${PublicGlobals.CDN_BASE_URL}/${orgId}/${assetName}`
  }

  static requireWithVersion(assetName: string) {
    return `/${PublicGlobals.UI_VERSION}/${assetName}`
  }

  static submitInputOnEnter(submitHandler: (event) => void) {
    if (!submitHandler) {
      return
    }

    return {
      onKeyDown: (event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          event.stopPropagation()
          submitHandler(event)
        }
      },
    }
  }

  static alphabetize(strings: string[]): string[] {
    return strings.sort((a, b) => a.localeCompare(b))
  }

  static normalizeParagraph(paragraphString: string): string {
    return paragraphString.replace(/([^\r\n\s].)[\r\n]([^\r\n\s])/g, '$1 $2')
  }

  static downloadGeneratedFile(fileContent: string, fileName: string, contentType: string) {
    const hiddenElement = document.createElement('a')
    hiddenElement.href = `data:${contentType};charset=utf-8,${encodeURI(fileContent)}`
    hiddenElement.target = '_blank'
    hiddenElement.download = fileName
    hiddenElement.click()
  }

  static hashText = sha256

  static generateId = nanoid

  static getQueryParams(location?: Location): { [p: string]: any } {
    let queryParams: URLSearchParams

    if (location) {
      queryParams = new URLSearchParams(location.search)
    } else {
      queryParams = new URLSearchParams(window.location.search)
    }

    queryParams.forEach((value, key) => (queryParams[key] = value))

    return queryParams
  }

  static navigateToQueryParams(queryParams: { [p: string]: any }) {
    const { createBrowserHistory } = require('history')
    const history = createBrowserHistory()
    const newURL = APIClient.createFullURLWithQueryParams(window.location.href, queryParams, true)
    history.push(newURL)
  }
}
